module.exports = __webpack_public_path__ + "img/tck.697e4653.png";